import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { FormControl, UntypedFormGroup } from "@angular/forms";
import { take } from "rxjs/operators";
import {
  SharedModule,
  FormInputComponent,
  RelationCustomFieldConfig,
  ModalService,
  CustomDetailComponent,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import SelectEventModalComponent from "../FanClubLink/LinkDetailNg/Select-Event-Modal/select.component";
import {
  Observable,
  combineLatest,
  map,
  distinctUntilChanged,
  startWith,
} from "rxjs";

type InputListItem = {
  id: number;
  // componentRef?: ComponentRef<FormInputComponent>;
  // control: UntypedFormControl;
};

@Component({
  imports: [SharedModule],
  standalone: true,
  templateUrl: "./product-event-section.component.html",
  styleUrl: "./product-event-section.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductEventSectionComponent
  implements OnInit, CustomDetailComponent
{
  listItems: any[] = [];
  //   private listFormArray = new FormArray([] as Array<FormControl<any>>);

  constructor(
    private modalService: ModalService,
    private notificationService: NotificationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  entity$: Observable<any>;
  detailForm: UntypedFormGroup;

  startTimeForm: FormControl;
  endTimeForm: FormControl;

  isFreeGift$: Observable<boolean>;
  isCorporate$: Observable<boolean>;
  customFieldForm: FormControl;

  visibility$: Observable<boolean>;

  ngOnInit(): void {
    this.startTimeForm = (
      this.detailForm.controls.customFields as UntypedFormGroup
    ).controls.startTime as FormControl;
    this.endTimeForm = (
      this.detailForm.controls.customFields as UntypedFormGroup
    ).controls.endTime as FormControl;

    this.formControl = (
      this.detailForm.controls.customFields as UntypedFormGroup
    ).controls.events as FormControl;

    this.isFreeGift$ = (
      this.detailForm.controls.customFields as UntypedFormGroup
    ).controls.freeGifts.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(this.detailForm.value.customFields.freeGifts)
    ) as Observable<boolean>;

    this.isCorporate$ = (
      this.detailForm.controls.customFields as UntypedFormGroup
    ).controls.isCorporate.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(this.detailForm.value.customFields.isCorporate)
    ) as Observable<boolean>;

    this.customFieldForm = this.detailForm.controls.customFields as FormControl;

    this.visibility$ = combineLatest([
      this.isFreeGift$,
      //this.isCorporate$,
    ]).pipe(
      map(([result1]) => {
        return !result1;
      })
    );

    this.isCorporate$.subscribe((isCorporate) => {
      const events = this.detailForm.value.customFields.events;
      if (isCorporate && events && events.length > 0) {
        if (!events[0].allowCorporate) {
          this.notificationService.error(
            "The event assigned to this product is not allowed for Corporate account"
          );
          this.customFieldForm.patchValue({
            isCorporate: false,
          });
        }
      }
    });

    this.formControl.valueChanges
      .pipe(
        distinctUntilChanged(),
        startWith(this.detailForm.value.customFields.events),
      )
      .subscribe((res) => {
        const events = res;

        if (events) {
          // if (this.listItems.length > 0) {
          //   return;
          // }
          this.listItems = [];
          for (const c of events) {
            this.listItems.push({
              id: c.id,
              name: c.name,
              startDate: c.startDate,
              endDate: c.endDate,
            });
          }
          this.changeDetectorRef.detectChanges();
          this.changeDetectorRef.markForCheck();
        }
      });
  }
  isListInput?: boolean | undefined = true;
  readonly: boolean;

  formControl: FormControl<any>;

  trackById(item: { id: number }) {
    return item.id;
  }

  moveListItem(event: CdkDragDrop<InputListItem>) {
    if (this.listItems) {
      moveItemInArray(this.listItems, event.previousIndex, event.currentIndex);
    }
  }

  removeListItem(item: InputListItem) {
    if (this.listItems) {
      const index = this.formControl.value.findIndex((i) => i === item);
      //this.listFormArray.removeAt(index);
      this.listItems = this.listItems.filter((i) => i !== item);
      this.formControl.patchValue(this.listItems.filter((i) => i !== item));
      this.formControl.markAsDirty();
    }
  }

  addListItem() {
    //console.log(this.customFieldForm);
    if (!this.listItems) {
      this.listItems = [];
    }

    this.modalService
      .fromComponent(SelectEventModalComponent, {
        size: "lg",
        closable: true,
        locals: {
          allowCorporate:
            this.customFieldForm.value.isCorporate === true ? true : undefined,
        },
      })
      .pipe(take(1))
      .subscribe((r) => {
        if (r && r.length > 0) {
          if (!this.listItems.find((i) => i.id === r[0].id)) {
            const data = r[0];

            if (this.listItems.length <= 0) {
              this.listItems.push(data);
            }

            this.startTimeForm.patchValue(data.startDate);
            this.endTimeForm.patchValue(data.endDate);

            this.formControl.patchValue([data]);

            this.formControl.markAsDirty();

            this.changeDetectorRef.markForCheck();
          }
        }
        this.customFieldForm.patchValue({
          isSinglePurchase: true,
        });
      });

    // this.listItems.push({
    //   id: this.listId++,
    // });
    //this.renderList$.next();
  }
}
